let swFile = '/sw.js';

registerServiceWorker();
installApp();

function registerServiceWorker() {
	
	/*
	для того, чтобы сервис-воркер можно было отлаживать на локальном домене, нужно создать ярлык на chrome со следующими параметрами и полностью перезагрузить его:
	"C:\Program Files\Google\Chrome\Application\chrome.exe" --unsafely-treat-insecure-origin-as-secure=http://lks.mos-gaz.lo
	*/
	
	if ('serviceWorker' in navigator) {
		
		navigator.serviceWorker.register(swFile).then(function (registration) {
			if(window.isLocalhost) {
				// console.log('ServiceWorker: Успешная регистрация');
			}
		}, function (err) {
			if(window.isLocalhost) {
				// console.log('ServiceWorker (произошла ошибка): ', err);
			}
		});
		
	}
	else {
		if(window.isLocalhost) {
			// console.log('ServiceWorker: нет поддержки на' + ' ' + window.location.protocol);
		}
	}
	
}

function installApp() {
	
	
	const installAppBtn = document.getElementById('install-app-btn');
	
	window.addEventListener('beforeinstallprompt', (e) => {
		
		e.preventDefault();
		window.deferredPrompt = e;
		
		localStorage.setItem('supportEventbeforeinstallprompt', true);
		
	});
	
	if(installAppBtn) {
		
		let coverFancy;
		let actualOutcome;
		
		installAppBtn.addEventListener('click', async (e) => {
			
			ym(METRIKA_COUNTER_ID,'reachGoal','open_in_app');
			
			if (typeof deferredPrompt !='undefined' && deferredPrompt !== null) {
				
				e.preventDefault();
				
				if(typeof actualOutcome === 'undefined') {
					
					coverFancy = $.fancybox.open('', {
						baseClass: 'fancy-app-cover',
						hash: false,
					});
					
				}
				
				if(typeof actualOutcome !== 'undefined') {
					$.fancybox.open($('[data-fancybox="app-repeat-click-btn"]'));
				}
				
				deferredPrompt.prompt();
				
				deferredPrompt.userChoice.then(() => {
					
					if(typeof coverFancy !== 'undefined') {
						coverFancy.close();
					}
					
				});
				
				const {outcome} = await deferredPrompt.userChoice;
				
				if (outcome === 'accepted') {
					window.deferredPrompt = null;
				}
				
				actualOutcome = outcome;
				
			}
			
			if( !localStorage.getItem('supportEventbeforeinstallprompt') ) {
				
				let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
				
				e.preventDefault();
				
				if(isSafari) {
					$.fancybox.open($('[data-fancybox="app-for-safari-browser"]'));
				}
				else {
					$.fancybox.open($('[data-fancybox="app-not-support"]'));
				}
				
				
			}
			
		});
		
		let isApp = window.matchMedia("(display-mode: standalone)").matches;
		
		if(isApp) {
			
			var visitParams = {
				is_standalone: true,
			};
			
			ym(METRIKA_COUNTER_ID, 'params', visitParams);
			
		}
		
	}
	
}